import { Tag } from '@carbon/react';
import {
  Document as DocumentIcon,
  WarningAltFilled,
  ArrowUp,
  ArrowDown,
  Link as LinkIcon,
} from '@carbon/react/icons';
import type { DocumentFlags } from '../types';
import styles from './document-card.module.scss';

const LEASE_LABELS: Record<string, string> = {
  'active': 'Active',
  'inactive': 'Inactive',
  'HBP': 'HBP',
  'partial HBP': 'Partial HBP',
};

// Green active / gray inactive / magenta (pink) HBP, per the mock.
const LEASE_TAG_TYPE: Record<string, 'green' | 'gray' | 'magenta'> = {
  'active': 'green',
  'inactive': 'gray',
  'HBP': 'magenta',
  'partial HBP': 'magenta',
};

// Mineral-lease status pill shown inline with the document title. Labels come
// from a map (not `.titleize`, which would turn "HBP" into "Hbp").
export const LeaseBadge = ({ status }: { status?: string | null }) => {
  if (!status) return null;
  return (
    <Tag type={LEASE_TAG_TYPE[status] ?? 'gray'} size="sm">
      {LEASE_LABELS[status] ?? status}
    </Tag>
  );
};

const FLAG_DEFS = [
  {
    key: 'supportingDocument',
    label: 'Supporting Document',
    Icon: DocumentIcon,
  },
  {
    key: 'curativeRequirements',
    label: 'Curative Requirements',
    Icon: WarningAltFilled,
  },
  { key: 'topLease', label: 'Top Lease', Icon: ArrowUp },
  { key: 'subjectToTopLease', label: 'Subject to Top Lease', Icon: ArrowDown },
  { key: 'relatedItems', label: 'Related Items', Icon: LinkIcon },
] as const;

// The text flags shown beneath the document citation.
export const DocumentFlagList = ({ flags }: { flags: DocumentFlags }) => {
  const active = FLAG_DEFS.filter((def) => flags[def.key]);
  if (active.length === 0) return null;
  return (
    <div className={styles.flagList}>
      {active.map(({ key, label, Icon }) => (
        <span key={key} className={styles.flag}>
          <Icon className={styles.flagIcon} />
          {label}
        </span>
      ))}
    </div>
  );
};
